<div>
    <app-alert-card 
        class="is-info"
        type="info" 
        title="Vigência a partir de 2027" 
        icon="event">
        O Imposto Seletivo (IS) entra em vigor a partir de 2027.
    </app-alert-card>

    <app-ativacao-section-card
        [control]="ativacaoControl"
        titulo="Imposto Seletivo"
        descricaoAtivo="Imposto Seletivo ativo. Esta regra tributária será considerada na apuração do IS a partir de 2027."
        descricaoInativo="Imposto Seletivo inativo. Esta regra tributária não apura IS."
        emptyStateDescricao="O Imposto Seletivo entrará em vigor a partir de 2027, não há edição disponível nesta tela.">
    </app-ativacao-section-card>

    @if (ativacaoControl.value) {
    <app-regra-tributaria-is-section [form]="isForm"></app-regra-tributaria-is-section>
    }
</div>
